import SkeletonGrid, { SkeletonItem } from '../loading/SkeletonGrid';
import { Box } from '@mui/material';

interface DataGridLoadingProps {
  columns: number;
}

/**
 * Reusable skeleton grid layout for datagrid loading matching rendered columns on data load.
 * @param {number} columns Number of columns that the datagrid is rendering and loading for.
 * @returns {JSX.Element}
 */
const DataGridLoading = ({ columns }: DataGridLoadingProps) => {
  const skeleton_grid_items: Array<SkeletonItem> = Array(columns).fill({
    size: 12 / columns,
    height: 40,
    variant: 'rounded'
  });
  return (
    <Box sx={{ my: 2 }}>
      <SkeletonGrid skeleton_items={skeleton_grid_items} />
    </Box>
  );
};

export default DataGridLoading;
